import { NextSeo } from 'next-seo';
import { Html } from 'next/document';
import Head from 'next/head';
import React from 'react';

import {
  ContactSalesView,
} from '@modules/propertyManagers/contactSales/ContactSalesView';
import { HeroView } from '@modules/propertyManagers/hero/HeroView';
import {
  OurSkilledView,
} from '@modules/propertyManagers/ourSkilled/OurSkilledView';
import {
  PaymentStructureView,
} from '@modules/propertyManagers/paymentStructure/PaymentStructureView';
import { ServicesView } from '@modules/propertyManagers/services/ServicesView';
import {
  TrustedPartnerView,
} from '@modules/propertyManagers/trustedPartner/TrustedPartnerView';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

const TITLE = 'Property Maintenance for London Property Managers | Qeeper';
const DESC =
  "Multi-trade maintenance services trusted by London's top letting agents. From plumbing to electrical work, we handle it all with flexible payment terms.";
const URL = 'https://www.qeeper.co.uk/property-managers';

const SEO_KEYWORDS =
  'property maintenance, property maintenance across London, Edinburgh and Brighton';

const PropertyManagersPage = () => {
  const faqItems = [
    {
      title: 'What areas do you currently service?',
      details: `We currently operate across London, Brighton, and Edinburgh, providing comprehensive property maintenance services to property managers in these regions.`,
    },
    {
      title:
        'How does your software integration work with our existing systems?',
      details:
        'The Qeeper app seamlessly integrates with popular property management systems including Fixflo. This means you can manage all maintenance requests, track job progress, and access reports without switching between platforms.',
    },
    {
      title: 'What’s included in your 12-month service guarantee?',
      details: `We offer a 12-month guarantee on labour carried out by a Qeeper tradesperson. If any issues arise from our completed work, we’ll resolve them for you. Check our Terms & Conditions for more details.`,
    },
    {
      title: 'How do credit accounts work?s',
      details: `We offer flexible credit account facilities to property management companies. This means simplified monthly billing, detailed reporting, and improved cash flow management. Contact James to discuss customized terms based on your portfolio needs.`,
    },
  ];

  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <>
        <HeroView />
        <TrustedPartnerView />
        <ServicesView />
        <OurSkilledView />
        <ContactSalesView />
        <PaymentStructureView />
        <FAQsView faqItems={faqItems} />
      </>
    </>
  );
};

PropertyManagersPage.getLayout = (page: any) => <Html>{page}</Html>;

export default PropertyManagersPage;
